import { useEffect, useRef } from "react";
import styles from "./index.module.css";
import { animated } from "@react-spring/web";

const PathAnimation = ({
  movieData,
  currentIndexDelay,
  lastIndexDelay,
  animate,
  onClick,
  movieNameStyles
}) => {
  const ctnRef = useRef(null);

  return (
    <animated.div
      className={`${styles.ctn} path-animation-ctn`}
      ref={ctnRef}
      onClick={onClick}
      data-cursor-magnetic
      data-cursor-size="120px"
      data-cursor-background-image="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-icon-play-mouse.png"
      style={{...movieNameStyles}}
    >
      <movieData.svg className={styles.svg} />
      <svg
        width="120"
        height="121"
        viewBox="0 0 120 121"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={styles.playIcon}
      >
        <rect
          x="0.5"
          y="0.584473"
          width="119"
          height="119"
          rx="59.5"
          fill="white"
        />
        <path d="M73 60.0845L53 48.0845V72.0845L73 60.0845Z" fill="#C03939" />
        <rect
          x="0.5"
          y="0.584473"
          width="119"
          height="119"
          rx="59.5"
          stroke="white"
        />
      </svg>
    </animated.div>
  );
};

export default PathAnimation;
